import React from 'react';

import { Box, Typography } from '@mui/material';

import { IrrAidaName } from '@components/ui/IrrAidaLogo';

import type { AnalystProperties } from './Analyst.types';

/**
 * Отображение информации об аналитике IRR(aida)
 */
export const Analyst: React.FC<AnalystProperties> = ({
  sx,
  dataTest = 'analyst',
}) => {
  return (
    <Box sx={sx} data-testid={dataTest}>
      <Typography
        variant='overline'
        data-testid={`${dataTest}_label`}
        sx={{
          color: 'text.secondary',
          fontWeight: 700,
          letterSpacing: 1,
          fontSize: '0.8rem',
        }}
      >
        Аналитик
      </Typography>
      <Box
        data-testid={`${dataTest}_content`}
        sx={{
          mt: { xs: 0.5, md: 1 },
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <Box
          component='img'
          src='/analytic.png'
          alt='IRR(aida)'
          data-testid={`${dataTest}_avatar`}
          sx={{
            width: { xs: 32, md: 40 },
            height: { xs: 32, md: 40 },
            borderRadius: '50%',
            objectFit: 'cover',
            boxShadow: 1,
            flexShrink: 0,
          }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <IrrAidaName
            variant='small'
            dataTest={`${dataTest}_name`}
          />
          <Typography
            variant='body2'
            data-testid={`${dataTest}_role`}
            sx={{
              fontSize: { xs: '0.75rem', md: '0.75rem' },
              fontWeight: 500,
              color: 'text.secondary',
              lineHeight: 1,
            }}
          >
            AI-платформа ФРИИ
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
